interface IParams {
  amount?: number | null;
  currency?: string;
  locale?: string;
  isRounded?: boolean;
  options?: Intl.NumberFormatOptions;
  invalidValue?: string;
}

export const formatPrice = ({
  amount,
  currency,
  locale = 'en-US',
  isRounded = false,
  invalidValue = 'n/a',
  options,
}: IParams) => {
  const quantity = Number(amount);

  if (amount === null || isNaN(quantity)) {
    return invalidValue;
  }

  const formatter = new Intl.NumberFormat(locale, {
    maximumFractionDigits: isRounded ? 0 : 2,
    minimumFractionDigits: isRounded ? 0 : undefined,
    style: 'currency',
    currency: currency || 'USD',
    currencyDisplay: 'symbol',
    ...options,
  });

  return formatter.format(quantity);
};
